module.exports = __webpack_public_path__ + "media/images/mailer/thumb_284-40db55f3ac436207be3410f1e7e9510d.jpg";